import { makeStyles } from 'tss-react/mui';
import { getColors, typography } from '../tokens';

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  return {
    root: {
      position: 'relative',
      width: '100%',
      minHeight: 340,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '96px 24px 48px',
      userSelect: 'none',
    },
    subtitle: {
      fontFamily: typography.fontFamilyCorpoATitle,
      fontSize: 48,
      fontWeight: 400,
      lineHeight: '95px',
      color: c.text.primary,
      textAlign: 'center',
      margin: 0,
      '@media (max-width: 768px)': {
        fontSize: 28,
        lineHeight: '50px',
      },
    },
    title: {
      fontFamily: typography.fontFamilyCorpoSText,
      fontSize: 83,
      fontWeight: 400,
      lineHeight: '95px',
      color: c.text.primary,
      margin: 0,
      textAlign: 'center',
      textTransform: 'lowercase',
      '@media (max-width: 768px)': {
        fontSize: 44,
        lineHeight: '55px',
      },
    },
  };
});

export interface ODPHeroProps {
  title?: string;
  subtitle?: string;
}

export const ODPHero = ({
  title = 'One Developer Portal',
  subtitle = 'Learn. Build. Ship.',
}: Readonly<ODPHeroProps>) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <p className={classes.subtitle}>{subtitle}</p>
      <h1 className={classes.title}>{title}</h1>
    </div>
  );
};
